module.exports = __webpack_public_path__ + "img/slide04.af7fbeb6.jpg";